import type { GenericTranslationsObject } from '@payloadcms/translations'

export const az: GenericTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-seo': {
    almostThere: 'Demək olar ki, çatdıq',
    autoGenerate: 'Avtomatik yaradılacaq',
    bestPractices: 'ən yaxşı təcrübələr',
    characterCount: '{{current}}/{{minLength}}-{{maxLength}} simvol, ',
    charactersLeftOver: '{{characters}} qalan',
    charactersToGo: '{{characters}} qalan',
    charactersTooMany: '{{characters}} çox',
    checksPassing: '{{current}}/{{max}} yoxlamalar uğurla keçdi',
    good: 'Yaxşı',
    imageAutoGenerationTip: 'Avtomatik yaradılma seçilən başlıq şəkilini əldə edəcək.',
    lengthTipDescription:
      'Bu, {{minLength}} ilə {{maxLength}} simvol arasında olmalıdır. Keyfiyyətli meta təsvirləri yazmaq üçün kömək üçün baxın ',
    lengthTipTitle:
      'Bu, {{minLength}} ilə {{maxLength}} simvol arasında olmalıdır. Keyfiyyətli meta başlıqları yazmaq üçün kömək üçün baxın ',
    missing: 'Yoxdur',
    noImage: 'Şəkil yoxdur',
    preview: 'Önizləmə',
    previewDescription: 'Dəqiq nəticələr, məzmun və axtarış uyğunluğuna görə dəyişə bilər.',
    tooLong: 'Çox uzun',
    tooShort: 'Çox qısa',
  },
}
